import React, { Component } from 'react';
import PropTypes from 'prop-types';
import _ from 'underscore';
import { unescapeHTML, titleize } from 'underscore.string';
import { withTranslation } from 'react-i18next';
import i18next from 'i18next';
import CargomaticInput from 'components/v2/input';
import LocationAutosuggest from 'components/site/location-autosuggest';
import SearchBox from 'components/site/SearchBox';
function getLocation(item) {
    if (item && item.name) {
        return item.name;
    }
    return i18next.t('UNKNOWN_LOCATION_NAME');
}
const createOnRemove = (item, onClick) => (e) => {
    e.stopPropagation();
    onClick(item);
};
const createRenderItem = (onClick) => (item) => (React.createElement("a", { key: item._id, className: "list-group-item", style: { cursor: 'pointer' } },
    React.createElement("div", { className: "flex justify-between" },
        React.createElement("p", { style: { cursor: 'pointer' }, className: "list-group-item-heading" },
            React.createElement("span", { className: "searchName" }, getLocation(item))),
        React.createElement("button", { className: "px-4 text-xl button", onClick: createOnRemove(item, onClick) },
            React.createElement("i", { className: "text-xl fa fa-close text-grey hover:text-grey-darker" })))));
class Location extends Component {
    constructor(props) {
        super(props);
        this.search = (nGram) => {
            const searchTerm = (nGram || '').toLowerCase();
            const filteredItems = (this.props.locations || []).filter((c) => (c.name || '').toLowerCase().includes(searchTerm));
            const locations = _.sortBy(filteredItems, (l) => (l.name || '').toLowerCase());
            this.setState({ locations });
        };
        this.handleRemoveLocation = (location) => {
            this.props.onRemoveLocation(location);
        };
        this.handleAutocompleteNameChange = (item) => this.props.onLocationFieldChange('name', item);
        this.handleNameChange = (value) => this.props.onLocationFieldChange('name', value);
        this.handleSuiteOrAptChange = (value) => this.props.onLocationFieldChange('suite_or_apt', value);
        this.handleNameSelect = (value, item) => this.props.onNameSelect(item);
        this.handleAddressSelect = (item) => {
            this.setState({ suggestions: [{ item }] }, () => {
                this.props.onAddressSelect({ location: item });
            });
        };
        this.handleAddressChange = (value) => {
            if (value === '') {
                this.props.onAddressSelect({ location: { address: '' } });
            }
        };
        this.state = { locations: props.locations };
    }
    onComponentDidMount() {
        const location = this.props.location || {};
        const name = location.name || '';
        if (name) {
            this.search(name);
        }
    }
    clear() {
        this.setState({ locations: [] });
    }
    render() {
        const { location, locations, sequence, t } = this.props;
        const hasLocations = locations && locations.length > 0;
        return (React.createElement("div", { className: "grid grid-cols-12 gap-x-2 gap-y-3" },
            React.createElement("div", { className: "col-span-full" },
                hasLocations && (React.createElement("div", { className: "relative" },
                    React.createElement(SearchBox, { id: `${sequence}-name`, appendItems: true, items: locations, clear: () => this.clear(), search: (nGram) => this.search(nGram), placeholder: t('LOCATION_NAME'), onChange: this.handleAutocompleteNameChange, onSelect: this.handleNameSelect, value: unescapeHTML(location.name), getItemValue: getLocation, renderItem: createRenderItem(this.handleRemoveLocation), menuStyle: { position: 'absolute', top: 40, left: 0 } }))),
                !hasLocations && (React.createElement(CargomaticInput, { type: "text", hideLabel: true, value: unescapeHTML(location.name), placeholder: t('ENTER_LOCATION_NAME'), onChange: (value) => this.handleNameChange(value), maxLength: 80 }))),
            React.createElement("div", { className: "col-span-7" },
                React.createElement(LocationAutosuggest, { className: "form-field", name: unescapeHTML(location.name), address: location.address, value: location.address, suggestions: [
                        {
                            name: location.name,
                            address: location.address,
                        },
                    ], callbackSelectedItem: this.handleAddressSelect, onChange: this.handleAddressChange, dropdownStyle: { maxHeight: '500px', overflow: 'auto' } })),
            React.createElement("div", { className: "col-span-5" },
                React.createElement(CargomaticInput, { type: "text", value: location.suite_or_apt, hideLabel: true, placeholder: t('SUITE_APT'), onChange: (value) => this.handleSuiteOrAptChange(value), maxLength: 80 })),
            React.createElement("div", { className: "col-span-5" },
                React.createElement(CargomaticInput, { type: "text", value: location.contact ? location.contact.name : '', hideLabel: true, placeholder: titleize(t('CONTACT', { count: 1 })), onChange: (value) => {
                        this.props.onLocationContactChange('name', value);
                    }, maxLength: 40 })),
            React.createElement("div", { className: "col-span-7" },
                React.createElement(CargomaticInput, { type: "phone", value: location.contact ? location.contact.phone : '', hideLabel: true, placeholder: titleize(t('PHONE', { count: 1 })), onChange: (value) => {
                        this.props.onLocationContactChange('phone', value);
                    }, maxLength: 25 }))));
    }
}
Location.propTypes = {
    location: PropTypes.object.isRequired,
    locations: PropTypes.array.isRequired,
    onNameSelect: PropTypes.func.isRequired,
    onAddressSelect: PropTypes.func.isRequired,
    onLocationFieldChange: PropTypes.func.isRequired,
    onLocationContactChange: PropTypes.func.isRequired,
    onRemoveLocation: PropTypes.func.isRequired,
};
export default withTranslation()(Location);
